module.exports = __webpack_public_path__ + "assets/img/w2.dd8616c9.png";